(function(){
  if (window.__bidulo) return; window.__bidulo = true;
  var d = document;
  d.documentElement.classList.add('bid-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Toast d’ajout au panier */
  var toastEl, toastTimer;
  var happy = ['🐸 Excellent choix. Tu viens officiellement de rejoindre le club.', '🐸 Gérard est dans ton panier. Il fait déjà comme chez lui.', '🐸 Adoption validée. Prépare le canapé.'];
  function toast(text, withLink) {
    if (!toastEl) { toastEl = d.createElement('div'); toastEl.className = 'bid-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); d.body.appendChild(toastEl); }
    toastEl.textContent = '';
    var s = d.createElement('span'); s.textContent = text || happy[Math.floor(Math.random() * happy.length)]; toastEl.appendChild(s);
    if (withLink !== false) { var a = d.createElement('a'); a.href = root + 'cart'; a.className = 'bid-toast__link'; a.textContent = 'Voir mon panier'; toastEl.appendChild(a); }
    requestAnimationFrame(function(){ toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer); toastTimer = setTimeout(function(){ toastEl.classList.remove('is-on'); }, 5000);
  }
  window.biduloToast = toast;

  /* Détecte tout ajout au panier, y compris celui du thème */
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function(input) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || String(input); } catch (e) {}
      var p = nativeFetch.apply(this, arguments);
      if (/\/cart\/add/.test(url)) { p.then(function(r){ if (r && r.ok) toast(); }).catch(function(){}); }
      return p;
    };
  }

  /* Formulaires d’achat Bidulo */
  d.addEventListener('submit', function(e){
    var f = e.target;
    if (!f.matches || !f.matches('[data-bid-buy]')) return;
    e.preventDefault();
    var b = f.querySelector('button[type=submit]');
    var label = b ? b.textContent : '';
    if (b) { b.disabled = true; b.textContent = 'Gérard enfile ses chaussons…'; }
    window.fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function(r){ if (!r.ok) throw new Error('add'); })
      .catch(function(){ toast('😬 Oups, Gérard s’est coincé dans la porte. Réessaie dans un instant.', false); })
      .then(function(){ if (b) { b.disabled = false; b.textContent = label; } });
  });

  /* Les yeux de Gérard suivent le curseur ou le doigt */
  var px = window.innerWidth / 2, py = window.innerHeight / 3, ticking = false;
  function updateEyes(){
    ticking = false;
    var faces = d.querySelectorAll('[data-bid-face]');
    for (var i = 0; i < faces.length; i++) {
      var f = faces[i], r = f.getBoundingClientRect();
      if (!r.width || r.bottom < 0 || r.top > window.innerHeight) continue;
      var k = r.width / 200, pupils = f.querySelectorAll('.bid-pupil');
      for (var j = 0; j < pupils.length; j++) {
        var pu = pupils[j];
        var ex = r.left + (+pu.getAttribute('data-cx')) * k, ey = r.top + (+pu.getAttribute('data-cy')) * k;
        var dx = px - ex, dy = py - ey, dist = Math.sqrt(dx * dx + dy * dy) || 1, m = Math.min(8, dist / 25);
        pu.setAttribute('transform', 'translate(' + (dx / dist * m).toFixed(2) + ' ' + (dy / dist * m).toFixed(2) + ')');
      }
    }
  }
  function look(x, y){ px = x; py = y; if (!ticking) { ticking = true; requestAnimationFrame(updateEyes); } }
  window.addEventListener('pointermove', function(e){ look(e.clientX, e.clientY); }, { passive: true });
  window.addEventListener('touchstart', function(e){ var t = e.touches[0]; if (t) look(t.clientX, t.clientY); }, { passive: true });
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(updateEyes); } }, { passive: true });

  /* Easter egg : chatouiller Gérard */
  var lines = ['Hé ! Ça chatouille.', 'Encore ? T’es sérieux ?', 'Je préviens : je mords pas. Enfin… presque.', 'Tu sais que je suis un pyjama, hein ?', 'Ok, t’as gagné. Pluie de bisous !'];
  function kisses(){
    if (reduce) return;
    for (var i = 0; i < 26; i++) {
      var s = d.createElement('span');
      s.className = 'bid-confetti'; s.setAttribute('aria-hidden', 'true');
      s.textContent = Math.random() < .55 ? '💋' : '🐸';
      s.style.left = (Math.random() * 100) + 'vw'; s.style.animationDelay = (Math.random() * .7) + 's'; s.style.fontSize = (18 + Math.random() * 20) + 'px';
      d.body.appendChild(s);
      setTimeout((function(el){ return function(){ el.remove(); }; })(s), 3600);
    }
  }
  d.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-bid-poke]');
    if (!btn) return;
    var n = (+btn.getAttribute('data-n') || 0) + 1;
    btn.setAttribute('data-n', n);
    var bub = btn.parentNode.querySelector('[data-bid-bubble]');
    if (bub) bub.textContent = lines[Math.min(n, lines.length) - 1];
    btn.classList.remove('bid-wobble'); void btn.offsetWidth; btn.classList.add('bid-wobble');
    if (n >= lines.length) { kisses(); btn.setAttribute('data-n', 0); }
  });

  /* Apparition douce au défilement */
  function initReveal(){
    var els = d.querySelectorAll('.bid-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { for (var i = 0; i < els.length; i++) els[i].classList.add('is-in'); return; }
    var io = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, { threshold: .12, rootMargin: '0px 0px -20px 0px' });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  /* Ridiculomètre */
  function initMeters(){
    var meters = d.querySelectorAll('[data-bid-meter]:not([data-init])');
    Array.prototype.forEach.call(meters, function(m){
      m.setAttribute('data-init', '1');
      var lab = m.querySelector('[data-bid-meter-label]');
      function go(){
        if (lab) lab.textContent = 'Mesure en cours…';
        m.classList.add('is-done');
        setTimeout(function(){ if (lab) lab.textContent = m.getAttribute('data-result') || 'LÉGENDAIRE'; }, reduce ? 0 : 2200);
      }
      if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function(en){ if (en[0].isIntersecting) { go(); io.disconnect(); } }, { threshold: .5 }); io.observe(m); } else { go(); }
      var again = m.querySelector('[data-bid-meter-again]');
      if (again) again.addEventListener('click', function(){ m.classList.remove('is-done'); if (lab) lab.textContent = 'Recalibrage…'; setTimeout(go, 450); });
    });
  }

  /* Petits détails cachés */
  var originalTitle = d.title;
  d.addEventListener('visibilitychange', function(){ if (d.hidden) { originalTitle = d.title; d.title = '🐸 Gérard s’ennuie sans toi…'; } else { d.title = originalTitle; } });
  try { console.log('%c🐸 Salut toi, curieux. Gérard te voit.', 'font-size:16px;font-weight:bold'); } catch (e) {}

  function init(){ initReveal(); initMeters(); updateEyes(); }
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
  d.addEventListener('shopify:section:load', init);
})();
(function(){
  function xmas(){
    var els = document.querySelectorAll('[data-bid-xmas-count]');
    if (!els.length) return;
    var now = new Date();
    var y = now.getFullYear();
    var target = new Date(y, 11, 25);
    if (now > new Date(y, 11, 25, 23, 59)) target = new Date(y + 1, 11, 25);
    var days = Math.ceil((target - new Date(y, now.getMonth(), now.getDate())) / 86400000);
    for (var i = 0; i < els.length; i++) els[i].textContent = days === 0 ? 'C’est Noël' : 'J-' + days;
  }
  if (document.readyState !== 'loading') xmas(); else document.addEventListener('DOMContentLoaded', xmas);
  document.addEventListener('shopify:section:load', xmas);
})();
(function(){
  if (window.__bidNav) return; window.__bidNav = true;
  var d = document;
  function nav(){ return d.querySelector('[data-bid-nav]'); }
  d.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-bid-burger]');
    var n = nav(); if (!n) return;
    if (b) {
      var open = !n.classList.contains('is-open');
      n.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      d.documentElement.classList.toggle('bid-menu-open', open);
      return;
    }
    if (e.target.closest && e.target.closest('.bid-nav__overlay a')) { n.classList.remove('is-open'); d.documentElement.classList.remove('bid-menu-open'); }
  });
  d.addEventListener('keydown', function(e){ var n = nav(); if (e.key === 'Escape' && n && n.classList.contains('is-open')) { var b = n.querySelector('[data-bid-burger]'); if (b) b.click(); } });
  var ticking = false;
  function stick(){ ticking = false; var n = nav(); if (!n) return; var top = n.getBoundingClientRect().top + window.scrollY; n.classList.toggle('is-stuck', window.scrollY > top + 8); }
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(stick); } }, { passive: true });
  stick();
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function refreshCount(){
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(c){
      var els = d.querySelectorAll('[data-bid-cart-count]');
      for (var i = 0; i < els.length; i++) { els[i].textContent = c.item_count; els[i].hidden = !c.item_count; els[i].classList.remove('is-bump'); void els[i].offsetWidth; els[i].classList.add('is-bump'); }
    }).catch(function(){});
  }
  if (window.fetch) {
    var f = window.fetch;
    window.fetch = function(input){
      var url = ''; try { url = typeof input === 'string' ? input : (input && input.url) || String(input); } catch (e) {}
      var p = f.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function(r){ if (r && r.ok) refreshCount(); }).catch(function(){});
      return p;
    };
  }
})();
(function(){
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function tick(){
    var els = document.querySelectorAll('[data-bid-countdown]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], end = Date.parse(el.getAttribute('data-end'));
      if (isNaN(end)) continue;
      var diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (diff === 0) {
        if (!el.classList.contains('is-done')) { el.classList.add('is-done'); var l = el.querySelector('.bid-countdown__label'); if (l) l.textContent = el.getAttribute('data-done'); }
        continue;
      }
      var v = { d: Math.floor(diff / 86400), h: Math.floor(diff % 86400 / 3600), m: Math.floor(diff % 3600 / 60), s: diff % 60 };
      for (var k in v) { var b = el.querySelector('[data-u=' + k + ']'); if (b) b.textContent = k === 'd' ? v[k] : pad(v[k]); }
    }
  }
  tick(); setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', tick);
})();
(function(){
  if (window.__bidCk) return; window.__bidCk = true;
  var d = document, el, api;
  function opts(){ var o = {}; el.querySelectorAll('[data-bid-ck-opt]').forEach(function(i){ o[i.getAttribute('data-bid-ck-opt')] = i.checked; }); return o; }
  function show(){ if (!el) return; el.hidden = false; requestAnimationFrame(function(){ el.classList.add('is-on'); }); }
  function hide(){ if (!el) return; el.classList.remove('is-on'); setTimeout(function(){ el.hidden = true; }, 450); }
  function save(c){
    var consent = { analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences, sale_of_data: !!c.marketing };
    if (api && api.setTrackingConsent) { api.setTrackingConsent(consent, function(){}); }
    hide();
    if (window.biduloToast) window.biduloToast(c.analytics || c.marketing ? '🍪 Miam. Merci, Gérard est rassasié.' : '🍪 C’est noté, Gérard garde ses cookies pour lui.', false);
  }
  function init(){
    el = d.querySelector('[data-bid-ck]');
    if (!el || !window.Shopify || !Shopify.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err){
      if (err) return;
      api = window.Shopify.customerPrivacy;
      if (!api) return;
      try {
        var cur = api.currentVisitorConsent ? api.currentVisitorConsent() : {};
        ['analytics','marketing','preferences'].forEach(function(k){ var i = el.querySelector('[data-bid-ck-opt=' + k + ']'); if (i) i.checked = cur && (cur[k] === 'yes'); });
      } catch (e) {}
      if (api.shouldShowBanner && api.shouldShowBanner()) setTimeout(show, 1200);
    });
  }
  d.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('[data-bid-ck-act],[data-bid-ck-open]');
    if (!t || !el) return;
    if (t.hasAttribute('data-bid-ck-open')) { show(); return; }
    var a = t.getAttribute('data-bid-ck-act');
    if (a === 'all') save({ analytics: true, marketing: true, preferences: true });
    else if (a === 'none') save({});
    else if (a === 'save') save(opts());
    else if (a === 'custom') {
      var p = el.querySelector('[data-bid-ck-prefs]'), s = el.querySelector('[data-bid-ck-act=save]');
      var open = p.hidden; p.hidden = !open; s.hidden = !open; t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
